/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React, { Fragment } from 'react'
import './PeriodEndDate.scss'
import { IInpatientTypeInsurance } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import { CommonUtils } from '../../../../utils/CommonUtils'

export interface IPeriodEndDateProps {
	data: IInpatientTypeInsurance
}
export class PeriodEndDate extends React.Component<IPeriodEndDateProps> {
	render(): React.ReactNode {
		const endDatePeriodInsuranceModel = this.props.data
		if (typeof endDatePeriodInsuranceModel !== 'undefined' && endDatePeriodInsuranceModel !== null) {
			return (
				<Fragment>
					<tr>
						<td>Plan End Date</td>
						<td colSpan={3}>{CommonUtils.toDisplayDate(endDatePeriodInsuranceModel.endOfPeriod2)}</td>
					</tr>
				</Fragment>
			)
		}
		return null
	}
}
